export enum StorageTypes {
    Global = "global",
    GlobalSession = "global-session",
    ExtendedGlobalSession = "extended-global-session",
}
